@if (address(); as address) {
  @switch (format()) {
    @case ('full') {
      <div class="address">
        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>

        <p>
          @if (address.street) {
            {{ address.street }} {{ address.houseNumber
            }}{{
              address.apartmentNumber ? '/' + address.apartmentNumber : ''
            }},
          }
          {{ address.zipCode }} {{ address.city }},
          {{ address.countryCode | uppercase }}
        </p>
      </div>
    }
    @case ('full-flag') {
      <div class="address">
        <p>
          @if (address.street) {
            {{ address.street }} {{ address.houseNumber
            }}{{
              address.apartmentNumber ? '/' + address.apartmentNumber : ''
            }},
          }
          {{ address.zipCode }} {{ address.city }}
        </p>

        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>
      </div>
    }
    @case ('extended') {
      <div class="extended-address">
        <div class="location">
          <ng-container
            *ngTemplateOutlet="
              flagTemplate;
              context: { countryCode: address.countryCode }
            "
          ></ng-container>

          <p class="location-container">
            {{ address.zipCode }}

            <span class="f-body-m f-semibold">{{ address.city }}</span>
          </p>
        </div>

        @if (address.street) {
          <div class="street f-muted">
            <p class="street-data">
              <span>
                {{ `${I18N}.streetShortcut` | translate }}
                {{ address.street }}
                {{ address.houseNumber }}
              </span>

              <span>{{ address.apartmentNumber ? ',' : '' }}</span>
            </p>

            @if (address.apartmentNumber) {
              <span>
                {{ `${I18N}.apartmentNumberShortcut` | translate }}
                {{ address.apartmentNumber }}
              </span>
            }
          </div>
        }

        <div class="coordinates f-muted">
          {{ address.coordinates.latitude }},
          {{ address.coordinates.longitude }}
        </div>
      </div>
    }
    @case ('short') {
      <div class="short-address">
        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>

        <div class="address-container">
          @if (address.street) {
            <p class="street">
              <span>{{ address.street }} {{ address.houseNumber }}</span>
              <span>
                {{
                  address.apartmentNumber ? '/' + address.apartmentNumber : ''
                }},
              </span>
            </p>
          }

          <span>{{ address.zipCode }} {{ address.city }}</span>
        </div>
      </div>
    }
    @case ('street-city') {
      <div class="address">
        <p>
          @if (address.street) {
            {{ address.street }} {{ address.houseNumber
            }}{{
              address.apartmentNumber ? '/' + address.apartmentNumber : ''
            }},
          }
          {{ address.city }}
        </p>
      </div>
    }
    @case ('transit') {
      @if (endAddress(); as endAddress) {
        <div class="address">
          {{ `${I18N_COUNTRY}.${address.countryCode}` | translate }},
          {{ address.city }} →
          {{ `${I18N_COUNTRY}.${endAddress.countryCode}` | translate }},
          {{ endAddress.city }}
        </div>
      } @else {
        -
      }
    }
    @case ('double-line') {
      <div class="double-line-address">
        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>

        <div class="container">
          @if (address.street) {
            <span>{{ address.street }} {{ address.houseNumber }}</span>
          }
          <span>{{ address.zipCode }} {{ address.city }}</span>
        </div>
      </div>
    }
    @case ('city') {
      <div class="city">
        <span>{{ address.zipCode }} {{ address.city }}, </span>
        <span>{{ address.countryCode | uppercase }}</span>
      </div>
    }
    @case ('city-flag') {
      <div class="city-flag">
        <span>{{ address.zipCode }}, {{ address.city }}</span>

        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>
      </div>
    }
    @case ('zip-code') {
      <div class="zip-code">
        {{ address.zipCode }}

        <ng-container
          *ngTemplateOutlet="
            flagTemplate;
            context: { countryCode: address.countryCode }
          "
        ></ng-container>
      </div>
    }
    @case ('pdf') {
      <div class="address">
        {{ `${I18N_COUNTRY}.${address.countryCode}` | translate }},
        {{ address.zipCode }} {{ address.city }}{{ address.street ? ',' : '' }}
        <br />
        @if (address.street) {
          {{ `${I18N}.streetShortcut` | translate }}
          {{ address.street }} {{ address.houseNumber
          }}{{ address.apartmentNumber ? '/' + address.apartmentNumber : '' }}
        }
      </div>
    }
    @case ('coordinates') {
      {{ coordinatesLabel() }}
    }
  }
} @else {
  -
}

<ng-template let-countryCode="countryCode" #flagTemplate>
  @if (showFlag()) {
    <onyx-flag [countryCode]="countryCode"></onyx-flag>
  }
</ng-template>
